import withModal, { ModalInProps } from '../../hocs/withModal';
import React, { SFC } from 'react';
import gql from 'graphql-tag';
import { contentBlockFragments, default as ContentBlocks } from './ContentBlocks';
import { DataProps, graphql } from 'react-apollo';
import { compose } from 'recompose';
import { RouteComponentProps, withRouter } from 'react-router';

import { ServiceParams } from '../Service';
import { getEntryOfType } from '../../services/entryTypes';
import { PricingPageFragment, PricingPageQuery } from '../../entities/operationResults';

const GET_PRICING_PAGE_QUERY = gql`
    query PricingPage ($exchange: [String!], $slug: [String!]) {
        service: entry(section: "info", site: $exchange, slug: $slug) {
            ...PricingPage
        }
    }
    
    fragment PricingPage on info_Entry {
        id
        contentBlocks {
            ...ContentBlock
        }
    }
    
    ${contentBlockFragments}
`;

interface InProps extends ModalInProps {
    slug: string;
    exchange: string;
}

interface OutProps extends RouteComponentProps<ServiceParams>, DataProps<PricingPageQuery> {
    slug: string;
}

const PricingSlideover: SFC<InProps & OutProps> = ({ data }) => {
    const pricingPage: PricingPageFragment | null = getEntryOfType('info_Entry', data.service);
    if (!pricingPage) { return null; }

    return (
        <ContentBlocks contentBlocks={pricingPage.contentBlocks} />
    );
};

const enhance = compose<OutProps, InProps>(
    withRouter,
    graphql(GET_PRICING_PAGE_QUERY, {
        options: ({ slug, exchange }: InProps) => ({
            variables: {
                slug,
                exchange
            }
        })
    }),
    withModal
);

export default enhance(PricingSlideover);